/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2020-04-30 11:24:05
 * @LastEditors: yy
 * @LastEditTime: 2020-08-24 13:43:23
 */
import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

// @ts-ignore
import s from './form.css';
import MysketchPicker from '../../../components/MysketchPicker/MysketchPicker';
import Collapse, { Panel } from '../../../components/Collapse/Collapse';

class WordCloudPane extends Component {

  constructor (props) {
    super(props)
    this.dataRef = null
    this.state = {
      fileImg: props.fileImg,
      list: props.list,
      useImg: props.useImg, 
      shape: props.shape,
      fontSpace: props.fontSpace,
      customColor: '0',
      color: '#000',
      errorStatus: {
        state: false,
        msg: ''
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const props = this.props
    if (nextProps.fileImg !== props.fileImg) this.setState({fileImg: nextProps.fileImg})
    if (nextProps.useImg !== props.useImg) this.setState({useImg: nextProps.useImg})
    if (nextProps.shape !== props.shape) this.setState({shape: nextProps.shape})
    if (nextProps.fontSpace !== props.fontSpace) this.setState({fontSpace: nextProps.fontSpace})
    if (nextProps.list !== props.list) {
      this.setState({list: nextProps.list})
      const dataDom = this.dataRef
      const TextAreaData = nextProps.list.map(item => {
        let result = item.name || ''
        if (item.value !== undefined) {
          result += `	${item.value}`
        }
        return result
      }).join('\n')
      dataDom.value = TextAreaData
    }
  }
  setError = (state, msg) => {
    this.setState({
      errorStatus: {
        state, msg
      }
    })
  }

  imgChange = (e) => {
    const file = e.target.files[0]
    this.setState({fileImg: file})
  }
  
  fieldChange = (key, val) => {
    this.setState({[key]: val})
  }

  textareaChange = (e) => {
    const {value} = e.target
    this.setError(false, '')
    const list = value.split('\n').map(item => {
      let itemArr = item.split(/\s/)
      const value = parseInt(itemArr.pop())
      if (isNaN(value)) this.setError(true, '数据格式错误')
      return {
        name: itemArr.join(' '),
        value,
      }
    })
    
    this.setState({list})
  }

  updateAllData = () => {
    const {onChange} = this.props
    const state = this.state
    onChange({...state})
  }

  render () {
    const {fileImg, useImg, shape, fontSpace, color, customColor,errorStatus} = this.state
    const style = {
      width: 200,
      height: 200
    } 

    return (
      <Collapse className={s.collapse}>
        <Panel header="字间距">
          <input type="number" value={fontSpace} onChange={(e) => {this.fieldChange('fontSpace', e.target.value)}} />
        </Panel>
        <Panel header="文字颜色">
          <select value={customColor} onChange={(e) => this.fieldChange('customColor', e.target.value)}>
            <option value="0">随机颜色</option>
            <option value="1">自定义颜色</option>
          </select>
          {customColor === '1' && <MysketchPicker value={color} onChange={val => {this.setState({color: val})}} />}
        </Panel>
        <Panel header="图形">
          <select value={useImg} onChange={(e) => this.fieldChange('useImg', e.target.value)}>
            <option value="0">形状</option>
            <option value="1">图片</option>
          </select>
          <hr/>
          {useImg === '1' ?
            <div>
              <input onChange={this.imgChange} type="file" /> 
              {fileImg && <img style={style} src={URL.createObjectURL(fileImg)} alt=""/>} 
            </div> :
            <select value={shape} onChange={(e) => this.fieldChange('shape', e.target.value)}>
              <option value="circle">圆形</option>
              <option value="cardioid">心形</option>
              <option value="diamond">菱形</option>
              <option value="triangle-forward">三角箭头</option>
              <option value="triangle">三角形</option>
            </select>
          }
        </Panel>
        <Panel header="数据" expand>
          <div>
            {/* <p style={{color: '#f00'}}>请确保数据没有空格</p> */}
            <textarea ref={ref => this.dataRef = ref} onBlur={this.textareaChange} cols={70} rows={8} />
          </div>
          {errorStatus.state && <p style={{color: '#f00'}}>{errorStatus.msg}</p>}

          <p style={{color: 'green'}}>请先更新数据再点生成图表</p>
          <button onClick={this.updateAllData}>更新数据</button>
        </Panel>
      </Collapse>
    )
  }
}




export default withStyles(s)(WordCloudPane)


// WEBPACK FOOTER //
// src/routes/customChart/components/WordCloudPane.js